import apiFetch from '../apiFetch'

export default function (idConductor, token) {
  return apiFetch({endPoint: `Transportista/comprobarEliminacionConductor?idConductor=` + idConductor, method: 'GET', body: null, token: token})
}